<template>
  <vs-tooltip color="primary" text="Preview" position="top">
    <vs-button
      type="border"
      icon-pack="feather"
      icon="icon-eye"
      @click.stop="params.colDef.CellRendererParams.openGradebookSidebar(params.data)"
    ></vs-button>
  </vs-tooltip>
</template>
<script>
export default {
  name: 'PreviewGradebookCell'
}
</script>